export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Main.vue?vue&type=template&id=7b85789e&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Main.vue?vue&type=template&id=7b85789e&
// module id = null
// module chunks = 